/**
 * Stable query keys shared by the Admin Raises Operations hooks and lifecycle
 * mutations on other role surfaces. Keeping the keys in a dependency-free module
 * lets owner/admin mutations invalidate each other's caches without creating a
 * circular dependency between their hook modules.
 */
export const raisesOpsKeys = {
  claims: ['raises-ops', 'claims'] as const,
  entitlements: ['raises-ops', 'entitlements'] as const,
  entitlementRequests: ['raises-ops', 'entitlement-requests'] as const,
  suppressions: ['raises-ops', 'suppressions'] as const,
  teasers: ['raises-ops', 'teasers'] as const,
  /** Full admin preview record for ONE teaser (by slug). */
  teaserPreview: (slug: string) => ['raises-ops', 'teaser-preview', slug] as const,
  /** Per-teaser identity grants for ONE teaser. */
  teaserGrants: (teaserId: number) => ['raises-ops', 'teaser-grants', teaserId] as const,
  /** All per-teaser identity grants across every teaser (central console). */
  allTeaserGrants: ['raises-ops', 'teaser-grants', 'all'] as const,
  /** Claim invites for ONE project. */
  invites: (projectId: number) => ['raises-ops', 'invites', projectId] as const,
};
